import veritoneApi from './veritoneApi';
import { get } from "lodash";
export function getVisualDataRefreshApi(urlApi) {
    return veritoneApi(urlApi.baseUrl)
        .get(`${urlApi.campaign}/dataRefresh/queue`)
        .then(response => 
            get(response, "data.data", [])
        )
        .catch(error => ({
            error: true,
            ...error
        }))
}

export function rerunVisualDataRefreshApi(urlApi, campaignId) {
    return veritoneApi(urlApi.baseUrl)
        .get(`${urlApi.campaign}/refresh/${campaignId}`)
        .then(response => response.data)
        .catch(error => ({error: true, ...error}));
}

export function removeVisualDataRefreshApi(urlApi, queueId) {
    return veritoneApi(urlApi.baseUrl)
    .get(`${urlApi.campaign}/dataRefresh/remove/${parseInt(queueId)}`)
    .then(response => response)
    .catch(error => ({
        error: true,
        ...error
    }))
}